webpackJsonp([237923725950639],{

/***/ 1256:
/***/ (function(module, exports) {

	module.exports = {"data":{"generalJson":{"card":"Detector","abilityText":"Opposing stealth and invisible forces are visible to you.","rulings":[{"ruling":null,"author":null,"date":null}]},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"detector"}}

/***/ })

});


// WEBPACK FOOTER //
// path---ruling-detector-4c154ce83b318e22a86a.js